import { type AppState } from 'src/redux/app/app.store'

export function selectAllVehicleIds(state: AppState) {
    return state.vehicleIds
}
